import React from "react";

export const CampaignsIcon = () => {
  return (
    <svg
      width="61"
      height="62"
      viewBox="0 0 61 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_496_1340)">
        <g clipPath="url(#clip1_496_1340)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.42258 55.7341C6.4242 55.2264 4.13672 52.6138 4.13672 49.4711C4.13672 45.9651 6.98321 43.1187 10.4892 43.1187C13.9952 43.1187 16.8417 45.9651 16.8417 49.4711C16.8417 52.6138 14.5542 55.2264 11.5559 55.7341L10.4892 58.1337L9.42258 55.7341Z"
            fill="#E4E9FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M49.2312 18.2342C46.2328 17.7265 43.9453 15.1139 43.9453 11.9712C43.9453 8.46515 46.7918 5.61865 50.2978 5.61865C53.8038 5.61865 56.6503 8.46515 56.6503 11.9712C56.6503 15.1139 54.3629 17.7265 51.3645 18.2342L50.2978 20.6337L49.2312 18.2342Z"
            fill="#E4E9FF"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.53422 56.821L9.34329 58.6418C9.54426 59.0934 9.99241 59.3851 10.4867 59.3851C10.9811 59.3851 11.4292 59.0934 11.6302 58.6418L12.4392 56.821C15.6906 55.9588 18.0907 52.9933 18.0907 49.4711C18.0907 45.2744 14.6834 41.8672 10.4867 41.8672C6.29006 41.8672 2.88281 45.2744 2.88281 49.4711C2.88281 52.9927 5.28289 55.9582 8.53422 56.821ZM10.4867 55.0804C10.2996 54.7743 9.9878 54.5612 9.62917 54.5006C7.221 54.0929 5.38569 51.9948 5.38569 49.4711C5.38569 46.6558 7.67144 44.3701 10.4867 44.3701C13.302 44.3701 15.5878 46.6558 15.5878 49.4711C15.5878 51.9948 13.7525 54.0929 11.3443 54.5006C10.9857 54.5612 10.6738 54.7743 10.4867 55.0804Z"
            fill="#3C51A0"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M50.2953 17.5804C50.1082 17.2743 49.7964 17.0612 49.4377 17.0006C47.0296 16.5929 45.1943 14.4948 45.1943 11.9711C45.1943 9.15581 47.48 6.87006 50.2953 6.87006C50.8884 6.87006 51.4578 6.97114 51.988 7.15767C52.6394 7.38694 53.3543 7.04448 53.5836 6.39306C53.8129 5.74164 53.4704 5.02669 52.819 4.79684C52.029 4.51906 51.1795 4.36719 50.2953 4.36719C46.0986 4.36719 42.6914 7.77443 42.6914 11.9711C42.6914 15.4933 45.092 18.4588 48.3434 19.3216L49.1519 21.1418C49.3528 21.5934 49.801 21.8851 50.2953 21.8851C50.7897 21.8851 51.2378 21.5934 51.4388 21.1418L52.2479 19.321C55.4992 18.4588 57.8993 15.4933 57.8993 11.9711C57.8993 10.42 57.4338 8.97736 56.6351 7.77385C56.2534 7.19866 55.4761 7.04101 54.9009 7.42331C54.3257 7.80504 54.168 8.58177 54.5498 9.15754C55.0851 9.96431 55.3964 10.9316 55.3964 11.9711C55.3964 14.4948 53.5611 16.5929 51.1529 17.0006C50.7943 17.0612 50.4824 17.2743 50.2953 17.5804Z"
            fill="#3C51A0"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.2934 59.1875H21.7947C22.485 59.1875 23.0453 58.6272 23.0453 57.9369C23.0453 57.2465 22.485 56.6862 21.7947 56.6862H19.2934C18.6031 56.6862 18.0428 57.2465 18.0428 57.9369C18.0428 58.6272 18.6031 59.1875 19.2934 59.1875ZM29.2984 59.1875H38.6781C45.2401 59.1875 50.5591 53.8686 50.5591 47.3066C50.5591 44.155 49.3072 41.1335 47.0798 38.9049C44.8512 36.6775 41.8297 35.4256 38.6781 35.4256C32.7226 35.4256 25.4127 35.4256 19.9187 35.4256C18.0941 35.4256 16.3445 34.7015 15.0551 33.4109C13.7644 32.1215 13.0403 30.3718 13.0403 28.5472C13.0403 26.7225 13.7644 24.9729 15.0551 23.6835C16.3445 22.3929 18.0941 21.6687 19.9187 21.6687H21.7947C22.485 21.6687 23.0453 21.1085 23.0453 20.4181C23.0453 19.7278 22.485 19.1675 21.7947 19.1675H19.9187C17.4313 19.1675 15.0451 20.1555 13.2867 21.9151C11.5271 23.6735 10.5391 26.0597 10.5391 28.5472C10.5391 31.0347 11.5271 33.4209 13.2867 35.1792C15.0451 36.9389 17.4313 37.9269 19.9187 37.9269H38.6781C41.1656 37.9269 43.5518 38.9149 45.3102 40.6745C47.0698 42.4329 48.0578 44.8191 48.0578 47.3066C48.0578 52.4866 43.8582 56.6862 38.6781 56.6862H29.2984C28.6081 56.6862 28.0478 57.2465 28.0478 57.9369C28.0478 58.6272 28.6081 59.1875 29.2984 59.1875ZM25.5466 21.6687H41.8047C42.495 21.6687 43.0553 21.1085 43.0553 20.4181C43.0553 19.7278 42.495 19.1675 41.8047 19.1675H25.5466C24.8562 19.1675 24.2959 19.7278 24.2959 20.4181C24.2959 21.1085 24.8562 21.6687 25.5466 21.6687Z"
            fill="#3C51A0"
          />
          <path
            d="M25.1374 59.1838C25.8281 59.1838 26.388 58.6239 26.388 57.9332C26.388 57.2425 25.8281 56.6826 25.1374 56.6826C24.4467 56.6826 23.8867 57.2425 23.8867 57.9332C23.8867 58.6239 24.4467 59.1838 25.1374 59.1838Z"
            fill="#3C51A0"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_496_1340">
          <rect
            width="60"
            height="61"
            fill="white"
            transform="translate(0.128906 0.758789)"
          />
        </clipPath>
        <clipPath id="clip1_496_1340">
          <rect
            width="60"
            height="61"
            fill="white"
            transform="translate(0.128906 0.758789)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
